/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import 'promise-polyfill';
import './bootstrap';

import './custom';

let Vue = require('vue').default;
window.Vue = Vue;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


import laroute from './laroute';
window.laroute = laroute;

import VuePikaday from '@netcz/vue-pikaday';
Vue.use(VuePikaday);


import Avatar from 'vue-avatar';
Vue.component('avatar', Avatar);

import ReactiveAvatar from './components/ReactiveAvatar.vue';
Vue.component('reactive-avatar', ReactiveAvatar);

import FaqList from './components/FaqList.vue';
Vue.component('faq-list', FaqList);

import Spinner from'./components/Spinner.vue';
Vue.component('spinner', Spinner);

import Pagination from './components/LaravelVuePagination.vue';
Vue.component('pagination', Pagination);

import PasswordStrengthMeter from './components/PasswordStrengthMeter.vue';
Vue.component('password-strength-meter', PasswordStrengthMeter);

import Registration from './components/Registration.vue';
Vue.component('registration', Registration);

import VatIdVerificator from './components/VatIdVerificator.vue';
Vue.component('vat-id-verificator', VatIdVerificator);

import PasswordField from './components/PasswordField.vue';
Vue.component('password-field', PasswordField);

import PasswordPolicyDisplay from './components/PasswordPolicyDisplay.vue';
Vue.component('password-policy-display', PasswordPolicyDisplay);

import UserTimezone from './components/UserTimezone.vue';
Vue.component('user-timezone', UserTimezone);

import ValidatedSubmitButton from './components/ValidatedSubmitButton.vue';
Vue.component('validated-submit-button', ValidatedSubmitButton);

import CardSlider from './components/CardSlider.vue';
Vue.component('card-slider', CardSlider);

import TestimonialsWidget from "./components/TestimonialsWidget.vue";
Vue.component('testimonials-widget', TestimonialsWidget);

import ContactForm from './components/ContactForm.vue';
Vue.component('contact-form', ContactForm);

Vue.filter('str_limit', function (string, value) {
    return string.substring(0, value) + '...';
});

function initVueApp() {
    const root = document.getElementById('vue-wrapper');
    if (!root) {
        return;
    }

    if (window.app && window.app.$destroy) {
        window.app.$destroy();
    }

    window.app = new Vue({
        el: root,
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVueApp);
} else {
    initVueApp();
}
